// extracted by mini-css-extract-plugin
export default {"listPageTitle":"listPageTitle_QYEy_Cj","spinner":"spinner_JU18RE8"};